import React from 'react';
import { CustomerWithMetrics, DashboardStats } from '../../hooks/useDashboardData';
import { SortOption, SegmentOption } from '../../hooks/useDashboardFilters';
import DashboardHeader from './DashboardHeader';
import DashboardStatsComponent from './DashboardStats';
import DashboardFilters from './DashboardFilters';
import CustomerTable from './CustomerTable';
import './TeamDashboard.css';

interface TeamDashboardViewProps {
  customers: CustomerWithMetrics[];
  stats: DashboardStats;
  selectedSegment: SegmentOption;
  sortBy: SortOption;
  onSegmentChange: (segment: SegmentOption) => void;
  onSortChange: (sort: SortOption) => void;
  onCustomerClick: (customerId: string) => void;
  onEditCustomer: (customer: CustomerWithMetrics) => void;
  onRefresh: () => void;
}

const TeamDashboardView: React.FC<TeamDashboardViewProps> = React.memo(({
  customers,
  stats,
  selectedSegment,
  sortBy,
  onSegmentChange,
  onSortChange,
  onCustomerClick,
  onEditCustomer,
  onRefresh,
}) => {
  return (
    <div className="team-dashboard" role="main" aria-label="Customer Onboarding Dashboard">
      <DashboardHeader onRefresh={onRefresh} />
      <DashboardStatsComponent stats={stats} />
      <DashboardFilters
        selectedSegment={selectedSegment}
        sortBy={sortBy}
        onSegmentChange={onSegmentChange}
        onSortChange={onSortChange}
      />
      <CustomerTable 
        customers={customers}
        onCustomerClick={onCustomerClick}
        onEditCustomer={onEditCustomer}
      />
    </div>
  );
});

TeamDashboardView.displayName = 'TeamDashboardView';

export default TeamDashboardView;